import { CONTENTS as ITEMS_CONTENTS } from '~/assets/collections/items';
import { CONTENTS as VEHICLES_CONTENTS } from '~/assets/collections/vehicles';
import { Subject } from '~/rage/utils';
import {
	ICharacterDonateItem,
	IClientConfigs,
	isClothesItem,
	RewardType,
} from '~/shared';
import { IInventoryDonateService } from './inventoryDonateServiceTypes';

export class InventoryDonateServiceStub implements IInventoryDonateService {
	private donateItems = new Subject<ICharacterDonateItem[]>([
		{
			id: 'ccl_m_1609',
			count: 1,
		},
		{
			id: 'bmw_7e38',
			count: 1,
		},
		{
			id: 'catfish',
			count: 1,
		},
		{
			id: 'bronze_case',
			count: 3,
		},
		{
			id: 'set_newbie',
			count: 1,
		},
		{
			id: 'money10000',
			count: 1,
		},
		{
			id: 'exp100',
			count: 1,
		},
		{
			id: 'test_item_3',
			count: 8,
		},
		{
			id: 'mod_kit_0_0',
			count: 2,
		},
	]);
	private itemsCount = new Subject<number>(this.donateItems.getValue().length);
	private lootboxesIds = new Subject<string[]>(['bronze_case', 'case_donater']);
	private bundlesIds = new Subject<string[]>(['set_newbie']);
	private donateInventoryItemsConfig: IClientConfigs['donate']['inventoryItems'] =
		[
			{
				itemId: 'ccl_m_1609',
				rewardType: RewardType.ITEM,
				rewardValue: 'ccl_m_1609',
				sellAmount: 500,
				sellIsDonate: false,
			},
			{
				itemId: 'bmw_7e38',
				rewardType: RewardType.VEHICLE,
				rewardValue: 'bmw_7e38',
				sellAmount: 10000,
				sellIsDonate: true,
			},
			{
				itemId: 'catfish',
				rewardType: RewardType.ITEM,
				rewardValue: 'catfish',
				sellAmount: 50,
				sellIsDonate: false,
			},
			{
				itemId: 'case_developer',
				rewardType: RewardType.LOOTBOX,
				rewardValue: 'case_developer',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'set_newbie',
				rewardType: RewardType.BUNDLE,
				rewardValue: 'set_newbie',
				sellAmount: null,
				sellIsDonate: null,
			},
		];

	public getDonateOwnedItems(): Subject<ICharacterDonateItem[]> {
		return this.donateItems;
	}

	public getTypeById(id: string): RewardType {
		const donateItem = this.donateInventoryItemsConfig.find(
			(item) => item.itemId === id,
		);
		if (donateItem) {
			return donateItem.rewardType;
		}
		if (
			ITEMS_CONTENTS.includes(id as (typeof ITEMS_CONTENTS)[number]) ||
			isClothesItem(id)
		) {
			return RewardType.ITEM;
		}
		if (VEHICLES_CONTENTS.includes(id as (typeof VEHICLES_CONTENTS)[number])) {
			return RewardType.VEHICLE;
		}
		if (this.lootboxesIds.getValue().includes(id)) {
			return RewardType.LOOTBOX;
		}
		if (this.bundlesIds.getValue().includes(id)) {
			return RewardType.BUNDLE;
		}
		if (id.startsWith('exp')) {
			return RewardType.EXP;
		}
		if (id.startsWith('money')) {
			return RewardType.MONEY;
		}
		return RewardType.ITEM;
	}

	public getItemsCount(): Subject<number> {
		return this.itemsCount;
	}

	public useReward(itemId: string): Promise<void> {
		console.log('inventoryDonate: useReward', itemId);
		return Promise.resolve();
	}

	public sellReward(itemId: string): Promise<void> {
		console.log('inventoryDonate: sellReward', itemId);
		return Promise.resolve();
	}

	public getPriceById(itemId: string): number | null {
		const donateItem = this.donateInventoryItemsConfig.find(
			(item) => item.itemId === itemId,
		);
		return donateItem?.sellAmount ?? null;
	}
}
